import {Component, Input, OnChanges, OnDestroy, SimpleChanges} from '@angular/core';
import {PointOptionsType} from 'highcharts';
import {Subject} from 'rxjs';
import {MonitoringDetailsService} from '../monitoring-details.service';
import {MetricType} from '../../../../models-monitoring';
import {ChartPoint} from '../../../../models';
import {ProcessorUsageService} from './processor-usage.service';

@Component({
    selector: 'app-processor-usage',
    templateUrl: './processor-usage.component.html',
    styleUrls: ['./processor-usage.component.scss']
})
export class ProcessorUsageComponent implements OnChanges, OnDestroy {

    @Input()
    serverId: number;

    @Input()
    metricType: MetricType;

    @Input()
    begin: Date;

    @Input()
    end: Date;

    @Input()
    resolution: number;

    dataSubject = new Subject<PointOptionsType[]>();
    chartPointList: ChartPoint[] = [];

    constructor(private monitoringDetailsService: MonitoringDetailsService,
                private service: ProcessorUsageService) {
        this.monitoringDetailsService.changePath('monitoring-details', 'processor');
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.chartPointList = [];
        this.service.loadFromDbAndWebSocket(this.begin, this.end, this.metricType, this.serverId, this.serverId, this.resolution, this.chartPointList, this.dataSubject);
    }

    ngOnDestroy(): void {
        this.chartPointList = [];
        this.dataSubject = new Subject<PointOptionsType[]>();
        this.service.unSubscribe();
    }
}
